module.exports = __webpack_public_path__ + "static/media/students-icon-3.1995bb56.svg";